import { render, staticRenderFns } from "./FeatureCardScada.vue?vue&type=template&id=987c6fdc&"
import script from "./FeatureCardScada.vue?vue&type=script&lang=js&"
export * from "./FeatureCardScada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports